import { ENTITLEMENT_SOURCE } from '@pvolve/sdk/src/app/modules/auth/constants';
import { concat } from 'lodash';

export interface SubnavItem {
    label: string;
    url?: string;
    pathname?: string;
    isGatsby?: boolean;
    classname?: string;
    filters?: string[];
}

export interface NavItem {
    label: string;
    subnav?: SubnavItem[];
    url?: string;
    classname?: string;
}

const SHARED_NAV_ITEMS = (shopifyDomain: string): NavItem[] => [
    {
        label: 'Studios',
        subnav: [
            {
                label: 'About',
                url: `${shopifyDomain}/pages/studio`,
            },
            {
                label: 'New York',
                url: `${shopifyDomain}/pages/new-york-studio`,
            },
            {
                label: 'Chicago',
                url: `${shopifyDomain}/pages/chicago-studio`,
            },
            {
                label: 'Los Angeles',
                url: `${shopifyDomain}/pages/los-angeles-studio`,
            },
            {
                label: 'Live Virtual Studio',
                url: `${shopifyDomain}/pages/virtual-studio-classes`,
                filters: [ENTITLEMENT_SOURCE.optum],
            },
            {
                label: 'Franchising',
                url: 'https://pvolvefranchise.com',
            },
        ],
    },
    {
        label: 'Shop',
        subnav: [
            {
                label: 'All',
                url: `${shopifyDomain}/collections/all`,
            },
            {
                label: 'Kits',
                url: `${shopifyDomain}/collections/kits-and-bundles`,
            },
            {
                label: 'Equipment',
                url: `${shopifyDomain}/collections/equipment`,
            },
            {
                label: 'Streaming Access',
                url: `${shopifyDomain}/products/streaming-access`,
            },
            {
                label: 'Apparel',
                url: `${shopifyDomain}/collections/apparel`,
            },
            {
                label: 'dvds',
                url: `${shopifyDomain}/collections/dvd-digital`,
            },
        ],
    },
    {
        label: 'Blog',
        subnav: [
            {
                label: 'All',
                url: `${shopifyDomain}/blogs/all`,
            },
            {
                label: 'Fitness',
                url: `${shopifyDomain}/blogs/all/tagged/fitness`,
            },
            {
                label: 'Lifestyle',
                url: `${shopifyDomain}/blogs/all/tagged/lifestyle`,
            },
            {
                label: 'Nutrition',
                url: `${shopifyDomain}/blogs/all/tagged/nutrition`,
            },
            {
                label: 'Travel',
                url: `${shopifyDomain}/blogs/all/tagged/travel`,
            },
            {
                label: 'Testimonials',
                url: `${shopifyDomain}/blogs/all/tagged/testimonial`,
            },
            {
                label: "Women's Wellness",
                url: `${shopifyDomain}/blogs/all/tagged/womens-wellness`,
            },
        ],
    },
];

const ENTITLED_NAV_ITEMS: NavItem[] = [
    {
        label: 'Streaming',
        subnav: [
            {
                label: 'My Plan',
                pathname: '/my-plan',
            },
            {
                label: 'Workouts',
                pathname: '/workouts',
            },
            {
                label: 'Series',
                pathname: '/series',
            },
        ],
    },
];

const UNENTITLED_NAV_ITEMS = (shopifyDomain: string): NavItem[] => [
    {
        label: 'Method',
        url: `${shopifyDomain}/pages/method`,
    },
    {
        label: 'Streaming',
        classname: 'streaming',
        subnav: [
            {
                label: 'How It Works',
                url: `${shopifyDomain}/pages/stream-your-workout`,
            },
            {
                label: 'Subscriptions',
                url: `${shopifyDomain}/products/streaming-access`,
            },
            {
                label: 'Workouts',
                pathname: '/workouts',
                isGatsby: true,
                classname: 'workouts',
            },
            {
                label: 'Series',
                pathname: '/series',
                isGatsby: true,
                classname: 'series',
            },
        ],
    },
];

const setShopifyUrl = (entitled: boolean, shopifyDomain: string) => {
    if (entitled) {
        return concat(ENTITLED_NAV_ITEMS, SHARED_NAV_ITEMS(shopifyDomain));
    }

    return concat(UNENTITLED_NAV_ITEMS(shopifyDomain), SHARED_NAV_ITEMS(shopifyDomain));
};

export const ENTITLED_NAV = setShopifyUrl;
export const UNENTITLED_NAV = setShopifyUrl.bind(this, false);
